<div class="row">
    <div class="col-sm-12">
      <h3 class="sub-title tex-center">Progress Email Status</h3>
    <div class="text-center">
      <button (click)="recompute()" class="btn btn-primary"> <i class="fa fa-plus"> </i> Recompute </button>
    </div>
  </div>
<div class="table-responsive" *ngIf="dataList.length>0">
  <table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
        <thead>
            <tr>
              <th>Email </th>
              <th>subject </th>
              <th>Body</th>
              <th>Test Send</th>
            </tr>
          </thead>
                <tbody>
                <tr *ngFor="let data of dataList">
                   <td>{{data['email']}}</td>
                    <td>{{data['subject']}}</td>
                    <td [innerHtml]="data['body']"></td>
                    <button class="btn btn-primary" (click)="testSend(data['email'])"><i class="fa fa-email"></i> Test</button>
                </tbody>
            </table>
    </div>
    <app-spinner *ngIf="loading"> </app-spinner>
